import { render } from "./Blobs.vue?vue&type=template&id=78974485&scoped=true"
import script from "./Blobs.vue?vue&type=script&lang=js"
export * from "./Blobs.vue?vue&type=script&lang=js"

import "./Blobs.vue?vue&type=style&index=0&id=78974485&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78974485"]])

export default __exports__